// extracted by mini-css-extract-plugin
export default {"cls1":"GroupCsvUpload-DragAndDropGrid_cls1__ph+I+","cls2":"GroupCsvUpload-DragAndDropGrid_cls2__8Bbc6 GroupCsvUpload-DragAndDropGrid_cls1__ph+I+"};